import { createAction, props } from '@ngrx/store';

export const NameSesChange = createAction('[SES CONFIGURATION]: Name Changed', props<{ nameSes: string }>());

export const StatusSesChange = createAction('[SES CONFIGURATION]: Status Changed', props<{ isActiveSes: boolean }>());

export const senderNamesSesChange = createAction(
  '[SES CONFIGURATION]: Sender Names Changed',
  props<{ senderNamesSes: string[] }>(),
);

export const SenderEmailAddressesSesChange = createAction(
  '[SES CONFIGURATION]: Sender Email Addresses Changed',
  props<{ senderEmailAddressesSes: string[] }>(),
);

export const ConfigurationSetsSesChange = createAction(
  '[SES CONFIGURATION]: Sender Email Addresses Changed',
  props<{ configurationSetsSes: string[] }>(),
);

export const ToggleIntegrationConfHelpTextStatus = createAction(
  '[SES CONFIGURATION]: Toggle Integration Configuration Help Text Status',
);

export const ToggleCampaignReportingHelpTextStatus = createAction(
  '[SES CONFIGURATION]: Toggle Campaign Reporting Help Text Status',
);

export const LookBackDaysSesChange = createAction(
  '[SES CONFIGURATION]: Look Back Days Ses Changed',
  props<{ lookBackDaysSes: number | null }>(),
);

export const AddEmptySenderName = createAction('[SES CONFIGURATION] Add Empty Sender Name');

export const SenderNamesChange = createAction(
  '[SES CONFIGURATION] Sender Names Change',
  props<{ index: number; value: string }>(),
);

export const RemoveSenderName = createAction('[SES CONFIGURATION] Remove Sender Name', props<{ index: number }>());

export const AddEmptySenderEmail = createAction('[SES CONFIGURATION] Add Empty Sender Email');

export const SenderEmailsChange = createAction(
  '[SES CONFIGURATION] Sender Emails Change',
  props<{ index: number; value: string }>(),
);

export const RemoveSenderEmail = createAction('[SES CONFIGURATION] Remove Sender Email', props<{ index: number }>());

export const AddEmptyConfSet = createAction('[SES CONFIGURATION] Add Empty Configuration Set');

export const ConfSetsChange = createAction(
  '[SES CONFIGURATION] Configuration Sets Change',
  props<{ index: number; value: string }>(),
);

export const RemoveConfSet = createAction('[SES CONFIGURATION] Remove Configuration Set', props<{ index: number }>());

export const CloseSesEditIntegration = createAction('[SES CONFIGURATION]:   Close Ses Edit Integration');

export const SesSubmitData = createAction('[SES CONFIGURATION]: Ses Submit Data');

export const EditSesIntegrationSystem = createAction(
  '[SES CONFIGURATION]: Edit Ses Integration System',
  props<{ sesData: any }>(),
);

export const SaveSesConfiguration = createAction('[Ses CONFIGURATION]: Save Ses Configuration');

export const SaveSesConfigurationSuccess = createAction(
  '[SES CONFIGURATION]: Save Ses Configuration Success',
  props<{ res: any }>(),
);

export const SaveSesConfigurationFailed = createAction(
  '[SES CONFIGURATION]: Save Ses Configuration Failed',
  props<{ error: any }>(),
);

export const UpdateSesConfiguration = createAction('[SES CONFIGURATION]: Update Ses Configuration');

export const UpdateSesConfigurationSuccess = createAction(
  '[SES CONFIGURATION]: Update Ses Configuration Success',
  props<{ res: any }>(),
);

export const UpdateSesConfigurationFailed = createAction(
  '[SES CONFIGURATION]: Update Ses Configuration Failed',
  props<{ error: any }>(),
);
